import { ValidationResult } from "src/app/ui/models/domains/validator/validation-result";
import { UntypedFormGroup } from "@angular/forms";
import { UserRole } from "src/app/ui/models/domains/pbm/user/user-role";
import { UserRoleTypes } from "src/app/ui/models/domains/pbm/user/user-role-types";

export class RegisterUserFormValidator {
  private validationResult = new ValidationResult();

  getValidationResult(): ValidationResult {
    return this.validationResult;
  }

  validate(userForm: UntypedFormGroup, isEditing: boolean): ValidationResult {
    const emailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*(){}\-_])[A-Za-z0-9#?!@$%^&*(){}\-_]{8,}$/;
    const userRole = userForm.get("userRole").value as UserRole;

    if (!userRole) {
      this.validationResult.addErrorMessage("É necessário selecionar ao menos um perfil.");
    }
    if (!userForm.get("name").value) {
      this.validationResult.addErrorMessage("É necessário inserir um nome.");
    }

    const isExternalManager = userRole.getUserRoleType() === UserRoleTypes.ExternalManager;
    const isCompanyManager = userRole.getUserRoleType() === UserRoleTypes.CompanyManager;

    if (isExternalManager && !userForm.get('externalClientId').value) {
      this.validationResult.addErrorMessage("Infromar o Client Id para usuário externo.");
    }
    
    if (!userForm.get("email").value) {
      this.validationResult.addErrorMessage("É necessário inserir um e-mail.");
    }

    if (!isExternalManager) {
      
      if (!emailRegex.test(userForm.get("email").value)) {
        this.validationResult.addErrorMessage("E-mail inválido.");
      }
      if (!emailRegex.test(userForm.get("email").value)) {
        this.validationResult.addErrorMessage("E-mail inválido.");
      }
      if (!userForm.get("telephone").value) {
        this.validationResult.addErrorMessage("É necessário inserir um telefone.");
      }
      if (userForm.get("telephone").value.replace(/[^\d]+/g, "").length < 10) {
        this.validationResult.addErrorMessage("Telefone inválido.");
      }
    }

    if (isCompanyManager || isExternalManager) {
      if (userForm.get("allowedCompanies").value.length == 0) {
        this.validationResult.addErrorMessage("É necessário selecionar ao menos um CNPJ.");
      }
      if (!userForm.get("fiscalNumber").value) {
        this.validationResult.addErrorMessage("É necessário inserir o CNPJ da empresa que o usuário é registrado.");
      } else if (userForm.get("fiscalNumber").value.replace(/[./-]/g, "").length < 14) {
        this.validationResult.addErrorMessage("CNPJ inválido.");
      }
    }

    if (!isExternalManager) {
      if (!isEditing && !passwordRegex.test(userForm.get("password").value)) {
        this.validationResult.addErrorMessage("Senha inválida");
      }
      if (isEditing && userForm.get("changePassword").value == true) {
        if (!passwordRegex.test(userForm.get("newPassword").value)) {
          this.validationResult.addErrorMessage("Senha inválida");
        } else if (passwordRegex.test(userForm.get("newPassword").value) && userForm.get("newPassword").value !== userForm.get("confirmNewPassword").value) {
          this.validationResult.addErrorMessage("A senha e a confirmação de senha precisam ser idênticas");
        }
      }
    }


    if (!this.validationResult.hasErrorMessages()) {
      if (userForm.get("isHealthProfessional").value) {
        if (!userForm.get("classCouncil").value) {
          this.validationResult.addErrorMessage("É necessário inserir um conselho de classe.");
        } else if (!userForm.get("registrationNumber").value) {
          this.validationResult.addErrorMessage("É necessário inserir um número de registro.");
        }
      }
    }
    return this.validationResult;
  }
}
